import History from '@/components/pages/about/history';
import EditHistory from '@/components/pages/about/edit_history';

import Member from '@/components/pages/about/member';
import EditMember from '@/components/pages/about/edit_member';

import Achievement from '@/components/pages/about/achievement';
import EditAchievement from '@/components/pages/about/edit_achievement';

import Plan_1F from '@/components/pages/about/plan_1F';
import EditPlan_1F from '@/components/pages/about/edit_plan_1F';

import Plan_2F from '@/components/pages/about/plan_2F';
import EditPlan_2F from '@/components/pages/about/edit_plan_2F';

import News from '@/components/pages/about/news';
import EditNews from '@/components/pages/about/edit_news';

import NewsDetail from '@/components/pages/about/news_detail';
import EditNewsDetail from '@/components/pages/about/edit_news_detail';

export default [
    {
        name: 'history',
        path: '/about/history',
        component: History
    },
    {
        name: 'edit_history',
        path: '/about/edit_history',
        component: EditHistory
    },
    {
        name: 'member',
        path: '/about/member',
        component: Member
    },
    {
        name: 'edit_member',
        path: '/about/edit_member',
        component: EditMember
    },
    {
        name: 'achievement',
        path: '/about/achievement',
        component: Achievement
    },
    {
        name: 'edit_achievement',
        path: '/about/edit_achievement',
        component: EditAchievement
    },
    
    {
        name: 'plan_1F',
        path: '/about/plan_1F',
        component: Plan_1F
    },
    {
        name: 'edit_plan_1F',
        path: '/about/edit_plan_1F',
        component: EditPlan_1F
    },
    {
        name: 'plan_2F',
        path: '/about/plan_2F',
        component: Plan_2F
    },
    {
        name: 'edit_plan_2F',
        path: '/about/edit_plan_2F',
        component: EditPlan_2F
    },
    {
        name: 'news',
        path: 'news',
        component: News
    },
    {
        name: 'edit_news',
        path: 'edit_news',
        component: EditNews
    },
    {
        name: 'news_detail',
        path: 'news_detail',
        component: NewsDetail,
        props: true
    },
    {
        name: 'edit_news_detail',
        path: 'edit_news_detail',
        component: EditNewsDetail,
        props: true
    },
];



// WEBPACK FOOTER //
// ./src/router/about/about.js